// src/components/card/CardBarcode.js
import React from 'react';
import { SAFE, DESIGN_W, POS } from './layout';

export default function CardBarcode({ px, value, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        position: 'absolute',
        left: px(SAFE + 40),
        top: px(POS.barcodeY + 50),
        width: px(DESIGN_W - (SAFE + 40) * 2),
        background: '#f0dfd4',
        borderRadius: px(18),
        padding: `${px(32)}px ${px(28)}px`,
        textAlign: 'center',
        zIndex: 2,
        boxShadow: '0 2px 8px rgba(94,58,26,.12)',
        border: `${px(2)}px solid #c28b4e`,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: px(18),
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width={px(64)}
        height={px(64)}
        fill="none"
        stroke="#5e3a1a"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="4" width="20" height="16" rx="2" />
        <line x1="6" y1="8" x2="6" y2="16" />
        <line x1="9" y1="8" x2="9" y2="16" />
        <line x1="12" y1="8" x2="12" y2="16" />
        <line x1="15" y1="8" x2="15" y2="16" />
        <line x1="18" y1="8" x2="18" y2="16" />
      </svg>
      <span style={{
        fontSize: px(42),
        fontWeight: 900,
        color: '#5e3a1a',
        letterSpacing: px(4),
      }}>
        {value ? '點擊查看條碼' : '尚未生成條碼'}
      </span>
    </div>
  );
}
